import React, { useState } from "react";
import "./AlarmCard.css";
import { BiCheckShield } from "react-icons/bi";
import Button from "../Button/Button";
import ModalComponent from "../Modal/ModalComponent";
import TextAreaInput from "../TextAreaInput/TextAreaInput";
import Select from "../Select/Select";
import EventsService from "../../services/EventsService";
import TimeConverter from "../../functions/TimeConverter";
import Spacer from "../Spacer/Spacer";

const AlarmCard = (props) => {
  const [modalFinishIsOpen, setModalFinishIsOpen] = useState(false);
  const [modalDetailsIsOpen, setModalDetailsIsOpen] = useState(false);
  const [alarmConfirmation, setAlarmConfirmation] = useState(false);
  const [alarmAction, setAlarmAction] = useState("");
  const [alarmResult, setAlarmResult] = useState("");
  const [cardVisibility, setCardVisibility] = useState(true);

  const handleFinishAlarm = () => {
    setModalFinishIsOpen(true);
  };
  const handleDetailsAlarm = () => {
    setModalDetailsIsOpen(true);
  };
  const handleConfirm = async (modalType) => {
    if (modalType === "finish") {
      const alarm = buildPayload();
      const response = await EventsService.updateEvent(alarm.id, alarm);
      setModalFinishIsOpen(false);
      setAlarmConfirmation(false);
      setAlarmAction("");
      setAlarmResult("");
      if (response.data) setCardVisibility(false);
    }
  };
  const handleCancel = (modalType) => {
    if (modalType === "finish") {
      setModalFinishIsOpen(false);
      setAlarmConfirmation(false);
      setAlarmAction("");
      setAlarmResult("");
    }
  };
  const buildPayload = () => {
    let alarmEventUpdated = props.alarm;
    alarmEventUpdated.visible_on_monitoring = false;
    alarmEventUpdated.alarm_confirmation = alarmConfirmation;
    alarmEventUpdated.alarm_action = alarmAction;
    alarmEventUpdated.alarm_result = alarmResult;
    return alarmEventUpdated;
  };
  return (
    cardVisibility && (
      <div className="alarm-card-container">
        <div style={{ display: "flex", alignItems: "center" }}>
          <BiCheckShield size={25} color={"var(--textColor)"} />
          <h1 className="alarm-card-title">Alerta - {props.alarm?.name}</h1>
        </div>
        <div style={{ display: "flex", alignItems: "baseline" }}>
          <Button
            label={"Finalizar"}
            className={"button-red alarm-details-button"}
            onClick={handleFinishAlarm}
          />
          <Button
            label={"Detalhes"}
            className={"button-white-red  alarm-details-button"}
            onClick={handleDetailsAlarm}
          />
        </div>
        <ModalComponent
          modalIsOpen={modalFinishIsOpen}
          modalText={"Finalização do evento:"}
          handleConfirm={() => handleConfirm("finish")}
          handleCancel={() => handleCancel("finish")}
        >
          <Select
            labelText="Confirmação"
            name="alarm_confirmation"
            id="alarm_confirmation"
            value={alarmConfirmation}
            onChange={({ target }) =>
              setAlarmConfirmation(Boolean(target.value))
            }
            required={true}
            options={[
              { value: true, text: "Alarme Confirmado" },
              { value: false, text: "Alarme Falso" },
            ]}
          />
          <Select
            labelText="Resultado"
            name="alarm_result"
            id="alarm_result"
            value={alarmResult}
            onChange={({ target }) => setAlarmResult(target.value)}
            required={true}
            options={[
              { value: "ignored", text: "Alarme Ignorado" },
              { value: "reported", text: "Alarme Reportado" },
              { value: "solved", text: "Alarme Resolvido" },
            ]}
          />
          <TextAreaInput
            labelText="Ação"
            name="alarm_action"
            id="alarm_action"
            type={"textfield"}
            value={alarmAction}
            onChange={({ target }) => setAlarmAction(target.value)}
            required={true}
          />
        </ModalComponent>
        <ModalComponent
          modalIsOpen={modalDetailsIsOpen}
          modalText={"Detalhes do alarme:"}
          hideButtons={true}
        >
          <div className="alarm-details-line">{"Id: " + props.alarm.id}</div>
          <div className="alarm-details-line">
            {"Evento: " + props.alarm.name}
          </div>
          <div className="alarm-details-line">
            {"Local: " + props.alarm.target_name}
          </div>
          {props.alarm?.user && (
            <div className="alarm-details-line">
              {"Usuário:" + props.alarm.user}
            </div>
          )}
          <div className="alarm-details-line">
            {"Data: " + TimeConverter(props.alarm.date, 2)}
          </div>
          <div className="alarm-details-line">
            {"Hora: " + props.alarm.time}
          </div>
          <Spacer marginBottom={20} />
          <Button
            className={"button-blue"}
            label={"Fechar"}
            onClick={() => setModalDetailsIsOpen(false)}
          />
        </ModalComponent>
      </div>
    )
  );
};

export default AlarmCard;
